





















import container from '@/model/ModelContainer';
import ISendVideoFileToKodiState from '@/model/state/recorded/detail/ISendVideoFileToKodiState';
import ISnackbarState from '@/model/state/snackbar/ISnackbarState';
import { ISendVideoFileSelectHostSettingStorageModel } from '@/model/storage/recorded/ISendVideoFileSelectHostSettingStorageModel';
import Util from '@/util/Util';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as apid from '../../../../../api';

@Component({})
export default class SendVideoFileToKodiDialog extends Vue {
    @Prop({ required: true })
    public recordedItem!: apid.RecordedItem;

    @Prop({ required: true })
    public videoFiles!: apid.VideoFile[];

    @Prop({ required: true })
    public isOpen!: boolean;

    public dialogState = container.get<ISendVideoFileToKodiState>('ISendVideoFileToKodiState');
    public isRemove: boolean = false;

    private snackbarState: ISnackbarState = container.get<ISnackbarState>('ISnackbarState');
    private setting = container.get<ISendVideoFileSelectHostSettingStorageModel>('ISendVideoFileSelectHostSettingStorageModel');

    /**
     * Prop で受け取った isOpen を直接は書き換えられないので
     * getter, setter を用意する
     */
    get dialogModel(): boolean {
        return this.isOpen;
    }
    set dialogModel(value: boolean) {
        this.$emit('update:isOpen', value);
    }

    public close(): void {
        this.dialogModel = false;
    }

    public async send(videoFileId: apid.VideoFileId): Promise<void> {
        try {
            await this.dialogState.send(videoFileId);
            this.snackbarState.open({
                color: 'success',
                text: '送信しました',
            });
        } catch (err) {
            this.snackbarState.open({
                color: 'error',
                text: '送信に失敗しました',
            });
        }
    }

    @Watch('isOpen', { immediate: true })
    public onChangeState(newState: boolean, oldState: boolean): void {
        if (newState === true && !!oldState === false) {
            const settingValue = this.setting.getSavedValue();
            this.dialogState.init(settingValue.hostName);
        } else if (newState === false && oldState === true) {
            // close
            this.setting.tmp.hostName = this.dialogState.hostName;
            this.setting.save();

            this.$nextTick(async () => {
                await Util.sleep(100);
                // dialog close アニメーションが終わったら要素を削除する
                this.isRemove = true;
                this.$nextTick(() => {
                    this.isRemove = false;
                });
            });
        }
    }
}
